export default "__VITE_ASSET__B0xetc82__"